/**
 * Dealer Locator jQuery App
 * PHP-integrated dealer locator with map + results list
 */

(function ($) {
	$(function () {
		const $container = $('#dealer-locator-app');
		if (!$container.length) {
			return;
		}

		const $form = $('#dealer-search-form');
		const $page = $('#dealer-locator-page');
		const $searchInput = $('#dealer-search-input');
		const $clearBtn = $('#dealer-clear-search');
		const $radiusSelect = $('#dealer-radius-select');
		const $tabButtons = $('.dealer-type-tab');
		const $submitButton = $('#dealer-search-submit');

		const $initialState = $('#dealer-initial-state');
		const $loadingState = $('#dealer-loading-state');
		const $errorState = $('#dealer-error-state');
		const $errorText = $('#dealer-error-text');
		const $dealerList = $('#dealer-list');
		const $resultsBox = $('.dealer-results-box');

		const $galleryShell = $('#dealer-gallery-shell');
		const $mapShell = $('#dealer-map-shell');

		const setResultsBoxVisible = isVisible => {
			$resultsBox.toggleClass('d-none', !isVisible);
		};

		const setSearchLayout = isSearchActive => {
			$container.toggleClass('search-active', isSearchActive);
			$page.toggleClass('dealer-search-active', isSearchActive);
		};

		const state = {
			dealerType: $container.data('type') || 'flooring',
			searchQuery: $container.data('search') || '',
			radius: parseInt($container.data('radius'), 10) || 50,
			dealers: [],
			selectedDealerId: null,
			userLocation: null,
			mapReady: false,
		};

		let map = null;
		let markers = [];
		let userMarker = null;

		const refreshMapLayout = () => {
			if (!map || !checkGoogleMaps()) {
				return;
			}

			const currentCenter = map.getCenter();
			google.maps.event.trigger(map, 'resize');

			if (markers.length) {
				const bounds = new google.maps.LatLngBounds();
				markers.forEach(marker => {
					const position = marker.getPosition();
					if (position) {
						bounds.extend(position);
					}
				});
				map.fitBounds(bounds);
				if (markers.length === 1) {
					google.maps.event.addListenerOnce(map, 'idle', () => {
						if (map.getZoom() > 12) {
							map.setZoom(12);
						}
					});
				}
				return;
			}

			if (currentCenter) {
				map.setCenter(currentCenter);
			}
		};

		const checkGoogleMaps = () => {
			return typeof google !== 'undefined' && typeof google.maps !== 'undefined';
		};

		const setDealerType = dealerType => {
			state.dealerType = dealerType;
			$tabButtons.removeClass('active').attr('aria-selected', 'false');
			$tabButtons
				.filter(`[data-type="${dealerType}"]`)
				.addClass('active')
				.attr('aria-selected', 'true');

			$form.toggleClass('quartz-mode', dealerType === 'quartz');
		};

		const showClearButton = () => {
			if ($searchInput.val().trim()) {
				$clearBtn.show();
			} else {
				$clearBtn.hide();
			}
		};

		const setLoading = isLoading => {
			if (isLoading) {
				setResultsBoxVisible(false);
				$loadingState.removeClass('d-none');
				$initialState.addClass('d-none');
				$errorState.addClass('d-none');
				$dealerList.addClass('d-none').empty();
				$submitButton.prop('disabled', true).text('Searching...');
				return;
			}

			$loadingState.addClass('d-none');
			$submitButton.prop('disabled', false).html('<i class="bi bi-search me-2"></i>Search');
		};

		const showError = message => {
			setResultsBoxVisible(false);
			$errorText.text(message);
			$errorState.removeClass('d-none');
			$initialState.addClass('d-none');
			$dealerList.addClass('d-none').empty();
		};

		const showInitial = () => {
			setSearchLayout(false);
			setResultsBoxVisible(false);
			$initialState.removeClass('d-none');
			$errorState.addClass('d-none');
			$dealerList.addClass('d-none').empty();
			$galleryShell.removeClass('d-none');
			$mapShell.addClass('d-none');
			clearMarkers();
			clearUserMarker();
		};

		const showMap = () => {
			$galleryShell.addClass('d-none');
			$mapShell.removeClass('d-none');
			if (!state.mapReady) {
				initMap();
			}

			requestAnimationFrame(() => {
				setTimeout(() => {
					refreshMapLayout();
				}, 60);
			});
		};

		const initMap = () => {
			if (state.mapReady || !checkGoogleMaps()) {
				return;
			}

			const mapEl = document.getElementById('dealer-map');
			if (!mapEl) {
				return;
			}

			map = new google.maps.Map(mapEl, {
				zoom: 4,
				center: { lat: 39.8283, lng: -98.5795 },
				mapTypeControl: false,
				streetViewControl: false,
				fullscreenControl: true,
			});

			state.mapReady = true;

			requestAnimationFrame(() => {
				setTimeout(() => {
					refreshMapLayout();
				}, 60);
			});
		};

		const clearMarkers = () => {
			markers.forEach(marker => marker.setMap(null));
			markers = [];
		};

		const clearUserMarker = () => {
			if (userMarker) {
				userMarker.setMap(null);
				userMarker = null;
			}
		};

		const renderUserMarker = () => {
			clearUserMarker();
			if (!state.userLocation || !state.mapReady) {
				return;
			}

			userMarker = new google.maps.Marker({
				position: state.userLocation,
				map,
				icon: {
					path: google.maps.SymbolPath.CIRCLE,
					fillColor: '#4285F4',
					fillOpacity: 1,
					strokeColor: '#fff',
					strokeWeight: 2,
					scale: 8,
				},
				title: 'Your Location',
			});
		};

		const getDirectionsUrl = dealer => {
			const address = encodeURIComponent(`${dealer.address} ${dealer.city} ${dealer.state}`);
			return `https://www.google.com/maps/dir/?api=1&destination=${address}`;
		};

		const normalizeDealerId = dealer => {
			return dealer.id || dealer.store_id || dealer.store_name;
		};

		const isQuartzSelection = () => state.dealerType === 'quartz';

		const renderDealerList = dealers => {
			if (!dealers.length) {
				showError('No dealers found. Please try a different search.');
				return;
			}

			setResultsBoxVisible(true);
			$errorState.addClass('d-none');
			$initialState.addClass('d-none');
			$dealerList.removeClass('d-none').empty();

			dealers.forEach((dealer, index) => {
				const id = normalizeDealerId(dealer);
				const typeClass = isQuartzSelection() ? 'quartz-type' : 'flooring-type';
				const distanceHtml = dealer.distance
					? `<div class="dealer-distance"><i class="bi bi-signpost-2"></i><span>${parseFloat(dealer.distance).toFixed(1)} miles away</span></div>`
					: '';

				const cardHtml = `
					<div class="dealer-card" data-dealer-id="${id}" data-marker-index="${index}">
						<div class="dealer-icon ${typeClass}">
							<span class="dealer-number">${index + 1}</span>
						</div>
						<div class="dealer-info">
							<h4 class="dealer-name">${dealer.store_name || ''}</h4>
							<p class="dealer-address">${dealer.address || ''}<br>${dealer.city || ''}, ${dealer.state || ''} ${dealer.zip || ''}</p>
							${
								dealer.phone
									? `<div class="dealer-contact"><i class="bi bi-telephone"></i><a href="tel:${dealer.phone}">${dealer.phone}</a></div>`
									: ''
							}
							${distanceHtml}
						</div>
					</div>
				`;

				$dealerList.append(cardHtml);
			});

			bindDealerCardEvents();
		};

		const selectDealer = dealerId => {
			state.selectedDealerId = dealerId;
			$dealerList.find('.dealer-card').removeClass('selected');
			$dealerList.find(`.dealer-card[data-dealer-id="${dealerId}"]`).addClass('selected');
		};

		const openMarkerInfo = marker => {
			markers.forEach(item => {
				if (item.infoWindow) {
					item.infoWindow.close();
				}
			});
			if (marker.infoWindow) {
				marker.infoWindow.open(map, marker);
			}
		};

		const bindDealerCardEvents = () => {
			$dealerList.find('.dealer-card').on('click', function (event) {
				if ($(event.target).closest('.btn-directions').length) {
					return;
				}

				const dealerId = String($(this).attr('data-dealer-id') || '');
				const markerIndex = parseInt($(this).attr('data-marker-index'), 10);
				const marker =
					(!Number.isNaN(markerIndex) && markers[markerIndex]) ||
					markers.find(item => String(item.dealerId) === dealerId);
				if (!marker) {
					return;
				}

				selectDealer(marker.dealerId);
				map.panTo(marker.getPosition());
				map.setZoom(14);
				openMarkerInfo(marker);
			});
		};

		const renderMapMarkers = dealers => {
			if (!state.mapReady || !map) {
				return;
			}

			clearMarkers();
			if (!dealers.length) {
				return;
			}

			const bounds = new google.maps.LatLngBounds();

			dealers.forEach((dealer, index) => {
				if (!dealer.lat || !dealer.lng) {
					return;
				}

				const position = {
					lat: parseFloat(dealer.lat),
					lng: parseFloat(dealer.lng),
				};

				if (Number.isNaN(position.lat) || Number.isNaN(position.lng)) {
					return;
				}

				const markerColor = isQuartzSelection() ? '#0092b0' : '#111';
				const dealerId = normalizeDealerId(dealer);

				const marker = new google.maps.Marker({
					position,
					map,
					title: dealer.store_name,
					label: {
						text: String(index + 1),
						color: '#fff',
						fontSize: '14px',
						fontWeight: 'bold',
					},
					icon: {
						path: 'M 0 0 C -2 -8 -10 -12 -10 -22 A 10 10 0 1 1 10 -22 C 10 -12 2 -8 0 0 Z',
						fillColor: markerColor,
						fillOpacity: 1,
						strokeColor: '#fff',
						strokeWeight: 3,
						scale: 1.35,
						anchor: new google.maps.Point(0, 0),
						labelOrigin: new google.maps.Point(0, -22),
					},
				});

				const infoWindow = new google.maps.InfoWindow({
					content: `
						<div class="map-info-window">
							<h4>${dealer.store_name || ''}</h4>
							<p class="address">${dealer.address || ''}<br>${dealer.city || ''}, ${dealer.state || ''} ${dealer.zip || ''}</p>
							${dealer.phone ? `<p class="phone"><i class="bi bi-telephone"></i> ${dealer.phone}</p>` : ''}
							<a href="${getDirectionsUrl(dealer)}" target="_blank" class="directions-link" rel="noopener">
								<i class="bi bi-map"></i> Get Directions
							</a>
						</div>
					`,
				});

				marker.dealerId = dealerId;
				marker.markerIndex = index;
				marker.infoWindow = infoWindow;

				marker.addListener('click', () => {
					selectDealer(dealerId);
					map.panTo(marker.getPosition());
					map.setZoom(14);
					openMarkerInfo(marker);
				});

				markers.push(marker);
				bounds.extend(position);
			});

			if (markers.length) {
				map.fitBounds(bounds);
				if (markers.length === 1) {
					google.maps.event.addListenerOnce(map, 'idle', () => {
						if (map.getZoom() > 12) {
							map.setZoom(12);
						}
					});
				}
			}
		};

		const geocodeQuery = query => {
			return new Promise(resolve => {
				if (!query || !checkGoogleMaps()) {
					resolve(null);
					return;
				}

				const geocoder = new google.maps.Geocoder();
				geocoder.geocode({ address: query }, (results, status) => {
					if (status === 'OK' && results && results[0] && results[0].geometry?.location) {
						resolve({
							lat: results[0].geometry.location.lat(),
							lng: results[0].geometry.location.lng(),
						});
						return;
					}
					resolve(null);
				});
			});
		};

		const requestDealers = payload => {
			return $.ajax({
				url: window.trendsData?.ajaxUrl || '/wp-admin/admin-ajax.php',
				type: 'POST',
				dataType: 'json',
				data: payload,
			});
		};

		const searchDealers = async () => {
			state.searchQuery = $searchInput.val().trim();
			state.radius = parseInt($radiusSelect.val(), 10) || 50;

			if (!state.searchQuery) {
				setSearchLayout(false);
				showInitial();
				return;
			}

			setSearchLayout(true);

			setLoading(true);
			showMap();

			try {
				let payload = {
					store_type: state.dealerType,
				};

				const coords = await geocodeQuery(state.searchQuery);
				if (coords) {
					state.userLocation = coords;
					payload = {
						...payload,
						action: 'search_stores_radius',
						lat: coords.lat,
						lng: coords.lng,
						radius: state.radius,
						unit: 'miles',
					};
				} else {
					state.userLocation = null;
					payload = {
						...payload,
						action: 'search_stores_keyword',
						keyword: state.searchQuery,
					};
				}

				const response = await requestDealers(payload);
				if (!response || !response.success) {
					throw new Error(response?.data || 'Failed to fetch dealers');
				}

				state.dealers = Array.isArray(response.data) ? response.data : [];
				renderDealerList(state.dealers);
				renderMapMarkers(state.dealers);
				renderUserMarker();
				refreshMapLayout();
			} catch (error) {
				showError(`Error: ${error.message || 'Something went wrong.'}`);
			} finally {
				setLoading(false);
			}
		};

		$tabButtons.on('click', function () {
			setDealerType($(this).data('type'));
			if ($searchInput.val().trim()) {
				searchDealers();
			}
		});

		$searchInput.on('input', showClearButton);

		$clearBtn.on('click', function () {
			$searchInput.val('');
			showClearButton();
			showInitial();
		});

		$form.on('submit', function (event) {
			event.preventDefault();
			searchDealers();
		});

		setDealerType(state.dealerType);
		$radiusSelect.val(String(state.radius));
		showClearButton();

		if (state.searchQuery) {
			searchDealers();
		} else {
			showInitial();
		}
	});
})(jQuery);
